import easelAPI, { EaselResponse } from 'apis/helpers/easelAPI'
import { multipartFormDataOptions } from 'apis/helpers/helpers'

export const submitSupportTicket = async (formData: FormData): Promise<EaselResponse> => {
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'submitSupportTicket',
    options: { ...multipartFormDataOptions, body: formData },
    url: `/support/ticket`,
  })
  return json
}

export const submitOrderSupportTicket = async (formData: FormData): Promise<EaselResponse> => {
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'submitOrderSupportTicket',
    options: { ...multipartFormDataOptions, body: formData },
    url: `/support/order-ticket`,
  })
  return json
}
